import React from 'react';
import { cn } from './lib/utils';

/* Secondary descriptive text under a control — parity with legacy
   `~co/common/form` SubLabel. */
export function SubLabel({ className, ...props }) {
  return (
    <div
      {...props}
      data-is-sub-label
      className={cn(
        'text-[length:var(--secondary-font-size)] text-muted-foreground [&:not(:last-child)]:mb-[var(--padding-small)]',
        className,
      )}
    />
  );
}
